<script setup lang="ts">
import PriceFont from "@/components/PriceFont.vue";
import Tabbar from "@/components/Tabbar.vue";
import _service from "@/service";
import moment from "moment";
import { Tabs, Tab, List } from "vant";
import { ref } from "vue";
const isShowPayModal = ref<boolean>(false);
const isShowDetailModal = ref<boolean>(false);
const showSelectList = ref<boolean>(false);
const tabActive = ref(0);
const ticketSelectIndex = ref(0);
const productSelectIndex = ref(0);
const categoryCurrentId = ref<string | number>("");
const loading = ref(false);
const finished = ref(false);
const triggered = ref(false);
const popup = ref(null);
const pageNo = ref(1);
const pageSize = ref(10);
const activeType = ref("");
const allOrderList = ref<any>([]);
const orderList = ref<any>({
  "0": {
    pageNo: 1,
    loading: false,
    list: [],
    finished: false,
  },
  "20": {
    pageNo: 1,
    loading: false,
    list: [],
    finished: false,
  },
  "30": {
    pageNo: 1,
    loading: false,
    list: [],
    finished: false,
  },
  "50": {
    pageNo: 1,
    loading: false,
    list: [],
    finished: false,
  },
  "60": {
    pageNo: 1,
    loading: false,
    list: [],
    finished: false,
  },
  "70": {
    pageNo: 1,
    loading: false,
    list: [],
    finished: false,
  },
  "80": {
    pageNo: 1,
    loading: false,
    list: [],
    finished: false,
  },
});

// const categoryList = ref<any>([
//   {
//     id:1,
//     name:'门票'
//   },
//   {
//     id:2,
//     name:'商品'
//   },
// ])

const statusListObj = {
  "0": "待支付",
  "20": "待收货",
  "30": "待使用",
  "50": "已退款",
  "60": "已转赠",
  "70": "已过期",
  "80": "已核销",
};

const getStatus = (data) => {
  switch (data.status) {
    case 0:
      return {
        class: "use-btn",
        text: "付款",
      };
      break;
    case 10:
      return {
        class: "text",
        text: "待发货",
      };
      break;
    case 20:
      return {
        class: "text",
        text: "发放中",
      };
      break;
    case 30:
      if (data.tickets?.length) {
        return {
          class: "use-btn",
          text: "出示二维码",
        };
      } else {
        return {
          class: "text",
          text: "已完成",
        };
      }
      break;
    case 40:
      return {
        class: "text gray",
        text: "已取消",
      };
      break;
    case 50:
      return {
        class: "text",
        text: "已退款",
      };
      break;
    case 60:
      return {
        class: "text",
        text: "已转赠",
      };
      break;
    case 70:
      return {
        class: "text gray",
        text: "已过期",
      };
      break;
    case 80:
      return {
        class: "text",
        text: "已核销",
      };
      break;
    default:
      return {
        class: "",
        text: "",
      };
      break;
  }
};

const handleChange = (name:string) => {
  console.log(name,'name-');
  
  activeType.value = name;
  if (!activeType.value) {
    getAllTicketList();
    return;
  }
  if (!orderList.value[activeType.value].list.length) {
    getTicketList();
  }
};

const getAllTicketList = async () => {
  // if (finished.value || loading.value) {
  //   return false;
  // }
  loading.value = true;
  const { data } = await _service.getUserOrderList({
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    status: "",
  });
  loading.value = false;
  triggered.value = false;
  if (data.list) {
    allOrderList.value = allOrderList.value.concat(data.list);
    pageNo.value++;
    if (allOrderList.value.length == data.total) {
      finished.value = true;
    }
  }
};

const getTicketList = async () => {
  if (
    orderList.value[activeType.value].finished ||
    orderList.value[activeType.value].loading
  ) {
    return false;
  }
  orderList.value[activeType.value].loading = true;
  const { data } = await _service.getUserOrderList({
    pageNo: orderList.value[activeType.value].pageNo,
    pageSize: pageSize.value,
    status: activeType.value,
  });
  orderList.value[activeType.value].loading = false;
  if (data.list) {
    orderList.value[activeType.value].list = orderList.value[
      activeType.value
    ].list.concat(data.list);
    orderList.value[activeType.value].pageNo++;
    console.log(orderList.value, "orderList.value[activeType.value].list");
    if (orderList.value[activeType.value].list.length == data.total) {
      orderList.value[activeType.value].finished = true;
    }
  }
};

const onLoad = () => {
  if (activeType.value) {
    getTicketList();
  }else{
    getAllTicketList()
  }
};
</script>

<template>
  <div class="my-order-layout">
    <div class="body">
      <Tabs v-model:active="activeType" @change="handleChange">
        <Tab title="全部" :name="undefined">
          <div class="tab-wrapper">
          <List v-model:loading="loading" :finished="finished" @load="onLoad">
              <div class="no-data" v-if="finished && !allOrderList.length">
                暂无数据
              </div>
              <div class="order-list">
                <div class="order-list-item" v-for="item in allOrderList" :key="item.id">
                  <!-- <div class="status-wrapper">
                <div class="status used"></div>
              </div> -->
                  <div class="flex-row-between-center">
                    <div class="left flex-col-between-start">
                      <p class="time flex-row-start-center">
                        {{moment(item.createTime).format('YYYY.MM.DD dddd HH:mm')}}
                      </p>
                      <p class="name">{{item?.items[0].spuName}}</p>
                    </div>
                    <img class="pic" :src="item?.items[0].picUrl" />
                  </div>
                  <p class="location flex-row-start-center">
                    <span class="location-icon"></span
                    ><span class="location-text"
                      >{{ `${item?.items[0].venueName} | ${item?.items[0].venueAddress}`}}</span
                    >
                  </p>
                  <div class="footer flex-row-between-center">
                    <p class="flex-row-start-end">
                      <PriceFont :price="item.payPrice" :count="item.productCount" :symbol="item.priceSymbol"></PriceFont>
                    </p>
                    <span v-if="item.status !== 30">{{getStatus(item).text}}</span>
                    <div class="right" v-else>
                      <div class="show-code-btn flex-row-center-center">
                        <span class="code-icon"></span>出示二维码
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </List>
          </div>
        </Tab>
        <Tab
          :title="value"
          v-for="(value, key) in statusListObj"
          :key="key"
          :name="key"
        >
          <div class="tab-wrapper">
            <!-- <div class="category-wrapper">
              <div class="category-bar flex-row-start-center">
                <div class="category-bar-item" :class="{'active':categoryCurrentId === ''}" @click="changeCategory()">全部</div>
                <div class="category-bar-item" :class="{'active':categoryCurrentId === item.id}" v-for="item in categoryList" :key="item.id" @click="changeCategory(item.id)">{{item.name}}</div>
              </div>
            </div> -->
            <List v-model:loading="orderList[key].loading" :finished="orderList[key].finished" @load="onLoad">
              <div class="no-data" v-if="orderList[key].finished && !orderList[key].list.length">
                暂无数据
              </div>
              <div class="order-list">
                <div class="order-list-item" v-for="item in orderList[key].list" :key="item.id">
                  <!-- <div class="status-wrapper">
                <div class="status used"></div>
              </div> -->
                  <div class="flex-row-between-center">
                    <div class="left flex-col-between-start">
                      <p class="time flex-row-start-center">
                        {{moment(item.createTime).format('YYYY.MM.DD dddd HH:mm')}}
                      </p>
                      <p class="name" v-if="item.items">{{item?.items[0].spuName || ''}}</p>
                    </div>
                    <img class="pic" v-if="item.items" :src="item?.items[0].picUrl || ''" />
                  </div>
                  <p class="location flex-row-start-center">
                    <span class="location-icon"></span
                    ><span class="location-text"  v-if="item.items"
                      >{{ `${item?.items[0].venueName} | ${item?.items[0].venueAddress}`}}</span
                    >
                  </p>
                  <div class="footer flex-row-between-center">
                    <p class="flex-row-start-end">
                      <PriceFont :price="item.payPrice" :count="item.productCount" :symbol="item.priceSymbol"></PriceFont>
                    </p>
                    <span v-if="item.status !== 30">{{getStatus(item).text}}</span>
                    <div class="right" v-else>
                      <div class="show-code-btn flex-row-center-center">
                        <span class="code-icon"></span>出示二维码
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </List>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.my-order-layout {
  height: 100%;
  height: 100vh;
  background: #000;
  overflow: hidden;
  .body {
    padding: 16px 12px;
    overflow: hidden;
    ::v-deep(.van-tabs) {
      margin: 0 -15px;
      .van-tabs__nav {
        background: transparent;
      }
      .van-tabs__wrap {
        height: 33px;
      }
      .van-tab--grow {
        padding: 8px;
      }
      .van-tabs__line {
        width: 25.914px;
        height: 5.638px;
        background: url(../../assets/tab-line.svg);
        background-size: contain;
        background-repeat: no-repeat;
        left: -1px;
      }
      .van-tab {
        color: #9c9caa;
        font-size: 14px;
      }
      .van-tab--active {
        color: #1cf2e4;
      }
      .van-tabs__content {
        height: calc(100vh - 70px);
        margin-top: 16px;
        overflow-y: scroll;
      }
    }
    .tab-wrapper {
      padding: 0 16px;
      /* margin-top:16px;
      height: calc(100vh - 74px);
      overflow-y: scroll; */
    }
    .tabs {
      gap: 30px;
      .tab {
        font-size: 18px;
        color: rgba($color: #fff, $alpha: 0.3);
        position: relative;
        font-weight: 600;
        &.active {
          color: #fff;
          &::after {
            position: absolute;
            width: 47px;
            height: 24px;
            right: -16px;
            bottom: -4px;
            content: "";
            display: inline-block;
            background: url(../../assets/active-tab.png);
            background-size: contain;
            background-repeat: no-repeat;
          }
        }
      }
    }
    .selector {
      font-size: 12px;
      color: #fff;
      margin-top: 12px;
      display: inline-block;
      z-index: 5;
      .down-icon {
        width: 16px;
        height: 16px;
        background: url(../../assets/down-icon.svg);
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: 4px;
      }
      .select-list {
        position: absolute;
        left: 0;
        top: 30px;
        width: 90px;
        padding: 0 16px;
        border-radius: 6px;
        background: #303342;
        &-item {
          height: 40px;
          color: #fff;
          line-height: 40px;
          font-size: 12px;
          font-weight: 400;
          border-bottom: 0.5px solid #545769;
          text-align: center;
          &:last-child {
            border-bottom: none;
          }
        }
        &::after {
          position: absolute;
          background: #303342;
          top: -4px;
          left: 20px;
          transform: rotate(45deg);
          display: inline-block;
          content: "";
          width: 8px;
          height: 8px;
        }
      }
    }
    .order-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      &-item {
        position: relative;
        width: 100%;
        padding: 12px;
        background: #fff;
        border-radius: 12px;
        background: #fff;
        .status-wrapper {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 12px;
          top: 0;
          left: 0;
          z-index: 5;
          background: rgba($color: #fff, $alpha: 0.8);
          .status {
            width: 88px;
            height: 88px;
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: 6;
            &.expired {
              background: url(../../assets/expired.png);
              background-size: contain;
              background-repeat: no-repeat;
            }
            &.used {
              background: url(../../assets/used.png);
              background-size: contain;
              background-repeat: no-repeat;
            }
            &.retired {
              background: url(../../assets/retired.png);
              background-size: contain;
              background-repeat: no-repeat;
            }
            &.gifted {
              background: url(../../assets/gifted.png);
              background-size: contain;
              background-repeat: no-repeat;
            }
          }
        }
        .left {
          width: 230px;
          height: 64px;
          .tag {
            display: flex;
            padding: 4px 8px;
            justify-content: center;
            align-items: center;
            font-size: 10px;
            font-size: 10px;
            font-weight: 500;
            border-radius: 8px 0px 8px 0;
            color: #fff;
            background: linear-gradient(196deg, #47e2b5 7.64%, #1fcfe7 81.25%);
            margin-right: 8px;
          }
          .time {
            font-size: 12px;
            color: #070b14;
          }
          .name {
            color: #000;
            font-size: 14px;
            font-weight: 500;
            margin-top: 6px;
            line-height: 1.4;
          }
        }
        .pic {
          width: 64px;
          height: 64px;
          border-radius: 12px;
        }
        .location {
          width: 100%;
          margin-top: 16px;

          &-icon {
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../../assets/location-icon.svg);
            background-size: contain;
            background-repeat: no-repeat;
          }
          &-text {
            width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            /* 将对象作为弹性伸缩盒子模型显示 */
            display: -webkit-box;
            /* 限制在一个块元素显示的文本的行数 */
            /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
            -webkit-line-clamp: 1;
            /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-box-orient: vertical;
          }
        }
        .footer {
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #eee;
          color: #ff3456;
          font-size: 12px;
          font-weight: 700;
          .number-font {
            font-size: 16px;
          }
          .count {
            color: #000;
            font-weight: 400;
            margin-left: 4px;
          }
          .right {
            width: 116px;
            height: 32px;
            .show-code-btn {
              width: 116px;
              height: 32px;
              border-radius: 100px;
              background: linear-gradient(
                111deg,
                #fff853 4.98%,
                #6eef94 56.05%,
                #2ad8cd 95.37%
              );
              color: #070b14;
              font-size: 12px;
              font-weight: 500;

              .code-icon {
                display: inline-block;
                width: 16px;
                height: 16px;
                background: url(../../assets/code-icon.svg);
                background-size: contain;
                background-repeat: no-repeat;
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
}

.category-wrapper {
  padding: 8px 0 4px 0;
}
</style>
